/**
 * ConfirmDialog — generic confirmation modal for consequential actions.
 */
import { AlertTriangle, X } from "lucide-react";

interface Props {
  open: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
}

export function ConfirmDialog({
  open,
  onClose,
  onConfirm,
  title,
  message,
  confirmLabel = "Confirm",
  cancelLabel = "Cancel",
}: Props) {
  if (!open) return null;

  return (
    <div className="confirm-scrim" onClick={onClose}>
      <div className="confirm-dialog" onClick={(e) => e.stopPropagation()}>
        <button
          className="ev-icon-btn"
          style={{ position: "absolute", top: 12, right: 12 }}
          onClick={onClose}
          aria-label="Close"
        >
          <X size={16} />
        </button>
        <div className="confirm-dialog-icon">
          <AlertTriangle size={24} />
        </div>
        <div className="confirm-dialog-title">{title}</div>
        <div className="confirm-dialog-message">{message}</div>
        <div className="confirm-dialog-actions">
          <button className="ev-btn ev-btn-outline" onClick={onClose}>
            {cancelLabel}
          </button>
          <button className="ev-btn ev-btn-primary" onClick={() => { onConfirm(); onClose(); }}>
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
